import { render, staticRenderFns } from "./Grave.vue?vue&type=template&id=ed59da96"
import script from "./Grave.vue?vue&type=script&lang=js"
export * from "./Grave.vue?vue&type=script&lang=js"
import style0 from "./Grave.vue?vue&type=style&index=0&id=ed59da96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports